import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable } from '@angular/core';
import { Observable, tap, map, catchError } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class AdminUserService {

 constructor(private readonly errorHandler:ErrorHandlerService, private readonly http: HttpClient) { }
 
   createAdminUser(data: any): Observable<any> {
     return this.http.post<any>(`${apiurl}/admin`, data).pipe(
       tap((response) => response)
     );
   }

   getAdminUsers(param:HttpParams=null): Observable<any> {
     return this.http.get<any>(`${apiurl}/admin`,{params:param}).pipe(
       tap((response) => response),
       catchError((error) => this.errorHandler.handleError(error))
     );
   }
 
   updateAdminUser(data: any): Observable<any> {
     return this.http.post<any>(`${apiurl}/admin/update`, data).pipe(
       tap((response) => response),
       catchError((error) => this.errorHandler.handleError(error))
     );
   }

   deleteAdminUser(data: any): Observable<any> {
     return this.http.post<any>(`${apiurl}/admin/delete`, data).pipe(
              tap((response) => response),
              catchError((error) => this.errorHandler.handleError(error))
            );
  }
}
